import * as z from 'zod';

import { AttachmentSchema } from '#packages/data-collection/models/common/attachment';

export const BuildingAndSystemsSchema = z.object({
  attachments: z.array(AttachmentSchema).optional(),
});

export type BuildingAndSystems = z.infer<typeof BuildingAndSystemsSchema>;
